import * as React from "react";
import { gql, useMutation, MutationFunction, ApolloError } from "@apollo/client";
import {
  DeleteOfferMutationMutation,
  DeleteOfferMutationMutationVariables
} from "../../../../schemaTypes";

export const deleteOfferMutation = gql`
  mutation DeleteOfferMutation($id: String!) {
    deleteOffer(id: $id) {
      errors {
        path
        message
      }
      message
    }
  }
`;

export interface WithDeleteOffer {
  deleteOffer: MutationFunction<DeleteOfferMutationMutation, DeleteOfferMutationMutationVariables>;
  data: DeleteOfferMutationMutation | undefined;
  loading: boolean;
  error?: ApolloError;
}

interface Props {
  children: (data: WithDeleteOffer) => React.ReactElement | null;
}

export const DeleteOffer: React.FC<Props> = ({ children }) => {
  const [deleteOffer, { data, loading, error }] = useMutation<
    DeleteOfferMutationMutation,
    DeleteOfferMutationMutationVariables
  >(deleteOfferMutation);

  return children({
    deleteOffer,
    data: data ?? undefined,
    loading,
    error
  });
};